document.addEventListener('DOMContentLoaded', function(){
    try {
        const swiperData = document.querySelector('.swiper-data');
        const nextButton = swiperData.querySelector('.swiper-related_next');
        const prevButton = swiperData.querySelector('.swiper-related_prev');

        const {
            viewDesktopLarge,
            viewDesktop,
            viewTablet,
            viewMobile,
            arrows
        } = swiperData.dataset;
    
        const breakpointsCustom = {
            580: {
                slidesPerView: viewTablet
            },
            1200: {
                slidesPerView: viewDesktop
            },
            1800: {
                slidesPerView: viewDesktopLarge
            },
        };
    
        let objectSwiper = {
            slidesPerView: 2.5,
            spaceBetween: 14,
            breakpoints: breakpointsCustom
        }
    
        if(arrows){
            objectSwiper = {
                ...objectSwiper,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                }
            }
        }
    
        const swiper = new Swiper('.swiper-related__collections', objectSwiper);
    } catch (error) {
        console.log('error en swiper data');
    }
});